import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
} from '@angular/core';
import { MissingFieldSection } from '../../../stewart/services/validate-stewart-data.service';
import { TitlePlusStatus } from '@models/title-insurance';
import { ICON } from '@core/util/icon';
import { MatDialog } from '@angular/material/dialog';
import { KeyDatesModalComponent } from 'src/app/private/sale/home/key-dates-modal/key-dates-modal.component';
import { NavigationService } from '@services/nav/nav.service';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TitlePlusModalComponent } from '../title-plus-modal/title-plus-modal.component';
import { UrlService } from '@services/url/url.service';
import { ChangePriorityComponent } from 'src/app/private/sale/mortgages/manual/components/change-priority/change-priority.component';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';
import { LeapDispatch } from 'src/app/public/leap/state/leap.dispatch';
import { TestHooks } from './title-plus-not-submitted.hooks';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';

@UntilDestroy()
@Component({
	selector: 'app-title-plus-not-submitted',
	templateUrl: './title-plus-not-submitted.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitlePlusNotSubmittedComponent implements OnInit {
	testHooks = TestHooks;
	@Input() changePropertyButtonText: string;
	@Input() canSubmit = false;
	@Input() missing: MissingFieldSection[] = [];
	@Input() orderValid = false;
	@Input() status;
	@Input() statusText: string;
	@Input() isOther = false;
	@Input() isMobileHome = false;
	@Input() outOfOntario = false;
	@Input() isLeasehold = false;
	@Input() isCommercial = false;
	@Input() showPriorityWarning = false;

	public TitlePlusStatus = TitlePlusStatus;
	public ICON = ICON;
	public backUrlParams = { 'back-string': 'Title insurance' };
	public keyDatesModalParams = { modal: 'keyDates' };
	public propertyUrl: string;

	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(
		private dialog: MatDialog,
		private navService: NavigationService,
		private route: ActivatedRoute,
		private analytics: AnalyticsService,
		private leapDispatch: LeapDispatch,
		private drawerService: DrawerService,
	) {}

	ngOnInit(): void {
		this.propertyUrl = UrlService.Matter_Property_Details(this.matterId);
	}

	openPortal() {
		if (!this.orderValid) {
			return;
		}

		if (!this.status) {
			//Means new order
			this.analytics.logEvent(AnalyticsEvent.TITLE_PLUS_POLICY_STARTED);
		}

		this.dialog.open(TitlePlusModalComponent);
	}

	editPriority(): void {
		this.dialog.open(ChangePriorityComponent, { panelClass: 'gradient' });
	}

	openKeyDatesDrawer(event: Event) {
		event.preventDefault();

		this.drawerService.openDrawer(KeyDatesModalComponent, {
			size: 'md',
			title: 'Key Dates',
			noStyle: true,
		});
	}
}
